import React from 'react';
import { MModalHeaderProps, MModalHeaderDEFAULT_I18N } from './MModalHeader.types';
import * as Styled from './MModalHeader.styles';
import { ASubheader } from '../../atoms/ASubheader';
import { MButtonIcon } from '../MButtonIcon';

const COMPONENT_NAME = 'm-web-ui-kit-MModalHeader';
const TEST_ID = 'web-ui-kit-MModalHeader';

export const MModalHeader: React.FC<MModalHeaderProps> = ({ aSubheader, mButtonIcon, i18nProperties, className }) => {
  const closeButtonAriaLabel =
    i18nProperties?.closeDialog ?? mButtonIcon['aria-label'] ?? MModalHeaderDEFAULT_I18N.closeDialog;

  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} className={className}>
      <Styled.SubheaderWrapper>
        <ASubheader {...aSubheader} />
      </Styled.SubheaderWrapper>
      <Styled.ButtonWrapper>
        <MButtonIcon {...mButtonIcon} aIcon={{ icon: 'icon-clear' }} aria-label={closeButtonAriaLabel} />
      </Styled.ButtonWrapper>
    </Styled.Wrapper>
  );
};
